import reportHelpers from '../include/helpers';

export default {
  budgetByProjects: {
    columns: [
      {
        accessorKey: 'task_name',
        // header: __('report_table_header_task_name'),
        header: __('group_by_task'),
        enableSorting: true,
        align: 'left',
        size: 'auto',
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'project',
        // header: __('report_table_header_project_name'),
        header: __('group_by_project'),
        enableSorting: true,
        enableGrouping: true,
        template: 'project',
        size: 132,
        icon: {
          name: 'project',
          type: 'regular',
          color: '#fff',
          size: 16,
        },
        align: 'left',
        cell: info => info.row.original.project.name,
        accessorFn: row => row.project.id,
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.original.project?.name;
          const bValue = rowB.original.project?.name;

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'assignee',
        // header: __('report_table_header_assignee'),
        header: __('gantt_grid_assigned'),
        enableGrouping: true,
        enableSorting: true,
        align: 'left',
        template: 'resource',
        size: 132,
        cell: info => info.row.original.assignee,
        accessorFn: row => row.assignee?.id ?? 0,
        sortingFn: (rowA, rowB) => {
          function getData(rowData) {
            return Array.isArray(rowData) ? rowData[0] : rowData;
          }

          const aValue = getData(rowA.original.assignee)?.name;
          const bValue = getData(rowB.original.assignee)?.name;

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'budget',
        // header: __('report_table_header_budget'),
        header: __('report_budget_by_projects_planned'),
        enableSorting: true,
        enableHiding: true,
        align: 'right',
        size: 132,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getFormattedBudgetValue(value);
        },
        aggregatedCell: info => {
          const value = info.getValue();

          return reportHelpers.getFormattedBudgetValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'baseline_budget',
        // header: __('report_table_header_budget'),
        header: __('report_budget_by_projects_baseline'),
        enableSorting: true,
        enableHiding: true,
        align: 'right',
        size: 132,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getFormattedBudgetValue(value);
        },

        aggregatedCell: info => {
          const value = info.getValue();

          return reportHelpers.getFormattedBudgetValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'actual_cost',
        // header: __('report_table_header_actual_cost'),
        header: __('report_budget_by_projects_actual'),
        enableSorting: true,
        enableHiding: true,
        align: 'right',
        size: 132,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getFormattedBudgetValue(value);
        },

        aggregatedCell: info => {
          const value = info.getValue();

          return reportHelpers.getFormattedBudgetValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'variance',
        // header: __('report_table_header_variance'),
        header: __('report_page_variance'),
        enableSorting: true,
        align: 'right',
        size: 148,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getFormattedBudgetValue(value);
        },

        aggregatedCell: info => {
          const value = info.getValue();

          return reportHelpers.getFormattedBudgetValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
    ],
    state: {
      columnPinning: {
        left: ['task_name'],
        right: ['variance'],
      },
      columnOrder: [
        'task_name',
        'project',
        'assignee',
        'baseline_budget',
        'budget',
        'actual_cost',
        'variance',
      ],
      columnVisibility: {
        task_name: true,
        project: true,
        assignee: true,
        baseline_budget: true,
        budget: true,
        actual_cost: true,
        variance: true,
      },
    },
    aggregatedColumns: ['baseline_budget', 'budget', 'actual_cost', 'variance'],
  },
  budgetByMonth: calculationModel => ({
    columns: [
      {
        accessorKey: 'month',
        // header: __('report_table_header_task_name'),
        header: __('month').charAt(0).toUpperCase() + __('month').slice(1),
        enableSorting: false,
        align: 'left',
        size: 'auto',
        cell: info => info.row.original.month,
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'baseline_budget',
        // header: __('report_table_header_budget'),
        header: __('report_budget_by_month_baseline_cost'),
        enableSorting: false,
        enableHiding: true,
        align: 'right',
        size: 132,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getFormattedBudgetValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'budget',
        // header: __('report_table_header_budget'),
        header: __('report_budget_by_month_planned_cost'),
        enableSorting: false,
        enableHiding: true,
        align: 'right',
        size: 132,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getFormattedBudgetValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'actual_cost',
        // header: __('report_table_header_actual_cost'),
        header: __('report_budget_by_month_actual_cost'),
        enableSorting: false,
        enableHiding: true,
        align: 'right',
        size: 132,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getFormattedBudgetValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'variance',
        // header: __('report_table_header_variance'),
        header: __('report_page_variance'),
        enableSorting: false,
        align: 'right',
        size: 132,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getFormattedBudgetValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'cum_baseline_budget',
        // header: __('report_table_header_budget'),
        header: __('report_budget_by_month_cumulative_baseline_cost'),
        enableSorting: false,
        enableHiding: true,
        size: 132,
        headerIconTooltip: {
          content: __('cum_baseline_budget_tooltip'),
          iconName: 'info',
          iconColor: '#808080',
        },
        align: 'right',
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getFormattedBudgetValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'cum_budget',
        // header: __('report_table_header_budget'),
        header: __('report_budget_by_month_cumulative_planned_cost'),
        enableSorting: false,
        enableHiding: true,
        size: 132,
        headerIconTooltip: {
          content: __('cum_budget_tooltip'),
          iconName: 'info',
          iconColor: '#808080',
        },
        align: 'right',
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getFormattedBudgetValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'cum_actual_cost',
        // header: __('report_table_header_actual_cost'),
        header: __('report_budget_by_month_cumulative_actual_cost'),
        enableSorting: false,
        enableHiding: true,
        size: 132,
        headerIconTooltip: {
          content: __('cum_actual_cost_tooltip'),
          iconName: 'info',
          iconColor: '#808080',
        },
        align: 'right',
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getFormattedBudgetValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'cum_variance',
        // header: __('report_table_header_variance'),
        header: __('report_page_variance_cumulative'),
        headerIconTooltip: {
          content: __(`report_table_s_curves_budget_cum_variance_tooltip_${calculationModel}`),
          iconName: 'info',
          iconColor: '#808080',
        },
        enableSorting: false,
        align: 'right',
        size: 148,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getFormattedBudgetValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
    ],
    state: {
      columnPinning: {
        left: ['month'],
        right: ['cum_variance'],
      },
      columnOrder: [
        'month',
        'baseline_budget',
        'budget',
        'actual_cost',
        'variance',
        'cum_baseline_budget',
        'cum_budget',
        'cum_actual_cost',
        'cum_variance',
      ],
      columnVisibility: {
        month: true,
        budget: true,
        baseline_budget: true,
        actual_cost: true,
        variance: true,
        cum_budget: true,
        cum_baseline_budget: true,
        cum_actual_cost: true,
        cum_variance: true,
      },
    },
  }),
  budgetByResource: {
    columns: [
      {
        accessorKey: 'task',
        // header: __('report_table_header_task_name'),
        header: __('group_by_task'),
        enableSorting: true,
        align: 'left',
        size: 'auto',
        icon: {
          name: 'task',
          type: 'regular',
          color: '#0D0D0D',
          size: 24,
        },
        cell: info => info.row.original.task.name,
        accessorFn: row => row.task.id,
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.original.task?.name;
          const bValue = rowB.original.task?.name;

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'project',
        // header: __('report_table_header_project_name'),
        header: __('group_by_project'),
        enableSorting: true,
        enableGrouping: true,
        template: 'project',
        size: 132,
        icon: {
          name: 'project',
          type: 'regular',
          color: '#fff',
          size: 16,
        },
        align: 'left',
        cell: info => info.row.original.project.name,
        accessorFn: row => row.project.id,
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.original.project?.name;
          const bValue = rowB.original.project?.name;

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'assignee',
        // header: __('report_table_header_assignee'),
        header: __('gantt_grid_assigned'),
        enableGrouping: true,
        enableSorting: true,
        align: 'left',
        template: 'resource',
        size: 132,
        cell: info => info.row.original.assignee,
        accessorFn: row => row.assignee?.id ?? 0,
        sortingFn: (rowA, rowB) => {
          function getData(rowData) {
            return Array.isArray(rowData) ? rowData[0] : rowData;
          }

          const aValue = getData(rowA.original.assignee)?.name;
          const bValue = getData(rowB.original.assignee)?.name;

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'budget',
        // header: __('report_table_header_budget'),
        header: __('report_budget_by_projects_planned'),
        enableSorting: true,
        enableHiding: true,
        align: 'right',
        size: 132,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getFormattedBudgetValue(value);
        },
        aggregatedCell: info => {
          const value = info.getValue();

          return reportHelpers.getFormattedBudgetValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'baseline_budget',
        // header: __('report_table_header_budget'),
        header: __('report_budget_by_projects_baseline'),
        enableSorting: true,
        enableHiding: true,
        align: 'right',
        size: 132,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getFormattedBudgetValue(value);
        },

        aggregatedCell: info => {
          const value = info.getValue();

          return reportHelpers.getFormattedBudgetValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'actual_cost',
        // header: __('report_table_header_actual_cost'),
        header: __('report_budget_by_projects_actual'),
        enableSorting: true,
        enableHiding: true,
        align: 'right',
        size: 132,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getFormattedBudgetValue(value);
        },

        aggregatedCell: info => {
          const value = info.getValue();

          return reportHelpers.getFormattedBudgetValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
      {
        accessorKey: 'variance',
        // header: __('report_table_header_variance'),
        header: __('report_page_variance'),
        enableSorting: true,
        align: 'right',
        size: 148,
        cell: info => {
          const value = info.getValue();

          return reportHelpers.getFormattedBudgetValue(value);
        },

        aggregatedCell: info => {
          const value = info.getValue();

          return reportHelpers.getFormattedBudgetValue(value);
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aValue = rowA.getValue(columnId);
          const bValue = rowB.getValue(columnId);

          return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
        },
      },
    ],
    state: {
      columnPinning: {
        left: ['task'],
        right: ['variance'],
      },
      columnOrder: [
        'task',
        'project',
        'assignee',
        'baseline_budget',
        'budget',
        'actual_cost',
        'variance',
      ],
      columnVisibility: {
        task: true,
        project: true,
        assignee: true,
        baseline_budget: true,
        budget: true,
        actual_cost: true,
        variance: true,
      },
    },
    aggregatedColumns: ['baseline_budget', 'budget', 'actual_cost', 'variance'],
  },
};
